package com.bikompanion.domain

enum class BikeType {
    Normal,
    Electric,
}
